export default import.meta.ROLLUP_FILE_URL_DQ5TTA_t;